class Callbacks {
  static formToFilterHandler(company) {
    return function formToFilter(values, extra, meta, state) {
      return {
        company
      }
    }
  }

  static formToRecordHandler(company) {
    return function formToRecord(values, extra, meta) {
      return {
        company,
        authorized_model: values?.authorized_model,
        active: values?.active,
        template: values?.template,
        export_start_date: values?.export_start_date
      }
    }
  }

  static getEmptyFormHandler() {
    return function getEmptyForm() {
      return {
        active: true,
        authorized_model: 'order'
      }
    }
  }
}

export default Callbacks
